Router = App.loadClass 'core::Router'
ReportsHandler = App.loadClass 'portal::handlers/reports/ReportsHandler'

class exports.ReportsRouter extends Router

    prefix: 'Reports'
    module_name: 'ReportsRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.reports',
                url: '/reports'
                template: '<div></div>'
                onEnter: ['$ngModal', '$http', ($ngModal, $http) ->
                    $(window).on 'reports.ussap-2bs-dialog', (event, data) =>
                        $http.get(data.url).then $ngModal.launchUssap2bsDeclarationsDialog(data.type)
                ]
                onExit: [() ->
                    $(window).off 'reports.ussap-2bs-dialog'
                ]
                controller: ['$scope', ($scope) ->
                    App.current_page = new ReportsHandler()
                    App.sidebar?.open?()
                    App.current_page.init()
                ]
